import { cn } from "@btnet/utilities-core";

import { BdsSection } from "@buildertrend/components";

import "./BdsSectionBox.less";

// Use a type alias instead of interface for component props
export type IBdsSectionBoxProps = React.ComponentProps<typeof BdsSection> & {
    /** Render the section flush, without the box border and padding
     * @default: false */
    borderless?: boolean;
};

const BdsSectionBox: React.FC<IBdsSectionBoxProps> = (props) => {
    const { className, borderless, ...restProps } = props;
    const mergedClassName = cn("bds-section-box", borderless && "border-0 p-0", className);
    return <BdsSection className={mergedClassName} {...restProps} />;
};

export default BdsSectionBox;
